<div class="section-wrapper">
  <vi-collapsable-ui>
    <div collapsable-ui-header class="full-width flex justify-between">
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.VOLUME_FLOW_EXPLANATION.TITLE' | translate
        }}
      </h3>

      <button
        gtm="onOpen"
        gtmAction="Permanent Inspection"
        gtmCategory="internalHydraulic"
        mat-stroked-button
        class="!h-fit show-diagnosis-btn"
        (click)="openRemoteInspectionOverlay()"
      >
        {{
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.VOLUME_FLOW_EXPLANATION.SHOW_DIAGNOSIS'
            | translate
        }}
      </button>
    </div>

    <div
      collapsable-ui-content
      [innerHTML]="
        '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.VOLUME_FLOW_EXPLANATION.CONTENT' | translate
      "
    ></div>
  </vi-collapsable-ui>
</div>
